var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],attrs:{"page-break":"","role":"tabpanel","id":`tabpanel-${_vm._uid}`,"aria-labelledby":`tab-${_vm._uid}`,"tabindex":"0"}},[_c('div',{staticClass:"mt-4"},[_vm._t("default",null,{"active":_vm.isActive})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }